<template lang="pug">
  .w-100.mh-100.h-100
    dx-data-grid(ref="grid"
      :data-source='!reportData.IsSummary ? reportData.Data.Data.Rows : reportSummary'
      :selection="{ mode: 'single' }"
      :show-borders='true'
      :style="{ height: localHeight, width: localWidth }"
      :columns="!reportData.IsSummary ? fields.filter(f => f.dataField !== 'ObjectName') : fields"
      :summary="summary"
      :row-alternation-enabled="true"
      :allow-column-reordering="true"
      :allow-column-dragging="false"
      @rowPrepared="rowColoring"
      @content-ready="onContentReady"
      @cell-click="onSelectionChanged")
      dx-scrolling(mode='virtual', :useNative="false")
      dx-sorting(mode="multiple")
      dx-load-panel(:enabled="true")
      dx-header-filter(:visible="true")
      dx-grouping(:auto-expand-all="reportData.IsSummary")
</template>
<script>
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';
import { SETTINGS_EVENTS } from '~/consts/eventTypes';

export default {
  name: 'Overspeed',
  components: {
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
    track: {
      type: Object,
      default () {
        return {};
      },
    },
    colors: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fields: [{
        dataField: 'ObjectName',
        caption: 'Объект',
        groupIndex: 0,
      }, {
        dataField: 'RowNum',
        caption: '№',
        fixed: true,
        alignment: 'right',
        width: 50,
      }, {
        dataField: 'Begin',
        caption: 'Начало',
        alignment: 'center',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        width: 120,
      }, {
        dataField: 'End',
        caption: 'Конец',
        alignment: 'center',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        width: 120,
      }, {
        dataField: 'Duration',
        name: 'Duration',
        caption: 'Длительность',
        alignment: 'center',
        width: 110,
      }, {
        dataField: 'MaxSpeed',
        name: 'MaxSpeed',
        caption: 'Максимальная скорость',
        alignment: 'center',
        width: 110,
      }, {
        dataField: 'BeginLocation',
        caption: 'Координаты начала',
      }, {
        dataField: 'EndLocation',
        caption: 'Координаты конца',
      }],
      summaryColoumn: [{
        column: 'RowNum',
        displayFormat: 'Итого:',
      }, {
        column: 'Duration',
        name: 'Duration',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'MaxSpeed',
        name: 'MaxSpeed',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }],
      summary: null,
      rowClick: null,
      reportSummary: [],
      periodBounds: null,
      index: 0,
    };
  },
  watch: {
    reportData (value) {
      this.rowClick = null;
      this.periodBounds = null;
      if (this.reportData.IsSummary) {
        this.convertSummaryData(this.reportData);
      }
      this.getSummary();
      this.getAddresses();
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
  },
  mounted () {
    if (this.reportData.IsSummary) {
      this.convertSummaryData(this.reportData);
    }
    this.getSummary();
    this.getAddresses();
    this.$eventBus.subscribe(
      SETTINGS_EVENTS.addressSettingsChanged,
      // eslint-disable-next-line no-underscore-dangle
      this._name,
      this.getAddresses,
    );
  },
  beforeDestroy () {
    this.$eventBus.unsubscribe(
      SETTINGS_EVENTS.addressSettingsChanged,
      // eslint-disable-next-line no-underscore-dangle
      this._name,
    );
  },
  methods: {
    rowColoring (el) {
      const { rowElement } = el;
      if (el.rowType === 'data') {
        if (el.data.EventType === 'нет информации' || el.data.EventType === 'потеряны спутники') {
          rowElement.classList.add('selected');
        }
      }
    },

    async onSelectionChanged (item) {
      if (item.rowType === 'data') {
        if (this.reportData.BuildTrack && this.track.Id) {
          if (!(this.rowClick && this.rowClick.Begin === item.data.Begin && this.rowClick.End === item.data.End)) {
            const timeZone = Number(this.reportData.TimeZone.split(':', 3)[0]);
            const periods = [[new Date((item.data.Begin - timeZone * 3600) * 1000), new Date((item.data.End - timeZone * 3600) * 1000)]];
            this.periodBounds = await this.$store.dispatch('tracks/updateTrack', { reportId: this.track.Id, secondColor: this.colors.alternative.hex, periods });
            this.reportData.periodsPartTrack = periods;
            this.rowClick = {
              Begin: item.data.Begin,
              End: item.data.End,
            };
          }
        }

        let latLonIsValid = (item.data.BeginLocationLatitude - item.data.BeginLocationLongitude) !== 0;
        if (['Begin', 'BeginLocation'].includes(item.column.dataField) && latLonIsValid) {
          const value = {
            lat: item.data.BeginLocationLatitude,
            lng: item.data.BeginLocationLongitude,
          };
          this.$store.commit('map/setCenter', value);
          this.$store.commit('tracks/setActivePoint', [value.lat, value.lng]);
        }

        latLonIsValid = (item.data.EndLocationLatitude - item.data.EndLocationLongitude) !== 0;
        if (['End', 'EndLocation'].includes(item.column.dataField) && latLonIsValid) {
          const value = {
            lat: item.data.EndLocationLatitude,
            lng: item.data.EndLocationLongitude,
          };
          this.$store.commit('map/setCenter', value);
          this.$store.commit('tracks/setActivePoint', [value.lat, value.lng]);
        }
        if (this.periodBounds !== null && (item.column.dataField === 'EventType' || item.column.dataField === 'Duration' || item.column.dataField === 'MaxSpeed')) {
          if (this.periodBounds.length > 3) {
            global.mainMap.fitBounds([
              [this.periodBounds[1], this.periodBounds[0]],
              [this.periodBounds[3], this.periodBounds[2]],
            ]);
          }
        }
      }
    },
    convertSummaryData (data) {
      const rows = [];
      data.Data.Data.forEach((items) => {
        items.Rows.forEach((_row, i) => {
          const row = _row;
          row.RowNum = i + 1;
          row.ObjectName = items.ObjectName;
          rows.push(row);
        });
      });
      this.reportSummary = rows;
    },
    getAddresses () {
      if (this.reportData.State === 'Done') {
        if (!this.reportData.IsSummary) {
          this.reportData.Data.Data.Rows.forEach((row) => {
            this.getAddress(row.BeginLocationLatitude, row.BeginLocationLongitude, row, true);
            this.getAddress(row.EndLocationLatitude, row.EndLocationLongitude, row, false);
          });
        } else {
          this.reportData.Data.Data.forEach((obj) => {
            obj.Rows.forEach((row) => {
              this.getAddress(row.BeginLocationLatitude, row.BeginLocationLongitude, row, true);
              this.getAddress(row.EndLocationLatitude, row.EndLocationLongitude, row, false);
            });
          });
        }
      }
    },
    getAddress (lat, lon, _row, begin) {
      const row = _row;
      const location = begin ? 'BeginLocation' : 'EndLocation';
      row[location] = null;
      setImmediate(async () => {
        const address = await this.$store.dispatch('nominatim/getAddress', { lat, lon });
        row[location] = address;
      });
    },
    getSummary () {
      if (!this.reportData.IsSummary) {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (options.summaryProcess === 'finalize') {
              const value = options;
              const totalValue = options.name === 'Duration' ? this.reportData.Data.Data[`Sum${options.name}`] : this.reportData.Data.Data[`${options.name}`];
              if (totalValue !== undefined) {
                value.totalValue = totalValue;
              }
            }
          },
          totalItems: this.summaryColoumn,
        };
      } else {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (options.summaryProcess === 'finalize') {
              const value = options;
              if (options.groupIndex === undefined) {
                const totalValue = options.name === 'Duration' ? this.reportData.Data[`Sum${options.name}`] : this.reportData.Data[`${options.name}`];
                if (totalValue !== undefined) {
                  value.totalValue = totalValue;
                }
                this.index = 0;
              } else {
                value.totalValue = options.name === 'Duration' ? this.reportData.Data.Data[this.index]?.SumDuration : this.reportData.Data.Data[this.index]?.MaxSpeed;
                if (options.name === 'MaxSpeed') {
                  this.index += 1;
                }
              }
            }
          },
          totalItems: this.summaryColoumn,
          groupItems: this.summaryColoumn.filter(x => x.column !== 'RowNum'),
        };
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
//.grid-wrap {
//  flex: 1;
//  overflow: hidden;
//}
</style>
